import * as React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import 'antd/dist/reset.css';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from "redux";
import { AgentPricingTab } from 'app/pages/AgentPricing/actionTypes';
import { getSelectedTab } from 'app/pages/AgentPricing/modules/TabMenuBar';
import { changeTabCommand } from 'app/pages/AgentPricing/commands';

export interface TabMenuBarProps {}

interface StateProps {
    selectedTab: AgentPricingTab;    
}

interface DispatchProps {
    setSelectedTab: (tab:AgentPricingTab) => void;
}

type InternalProps = StateProps & DispatchProps; 

const keyOf = (t: AgentPricingTab) => String(t);
const parseKey = (k: string) =>
  (Number.isNaN(Number(k)) ? (k as unknown as AgentPricingTab) : (Number(k) as unknown as AgentPricingTab));

function makeTabItem(label:string, tab:AgentPricingTab): NonNullable<TabsProps['items']>[number] {
  return { key: keyOf(tab), label };
}

const TabMenuBar = (props:InternalProps) => {
  const items: TabsProps['items'] = [
    makeTabItem('Group Rates', AgentPricingTab.GroupRates),
    makeTabItem('Company Rates', AgentPricingTab.CompanyRates),
    makeTabItem('Version history', AgentPricingTab.VersionHistory),
  ];

  return (
    <Tabs
      type="card"
      items={items}
      activeKey={keyOf(props.selectedTab)}
      onChange={(k) => props.setSelectedTab(parseKey(k))}
    />
  );
};

const mapStateToProps = (state:any, ownProps: TabMenuBarProps) => {
    const selectedTab = getSelectedTab(state);
    return {
        selectedTab
    }
};

const mapDispatchToProps = (dispatch:ThunkDispatch<any, any, Action>, ownProps: TabMenuBarProps) => ({
    setSelectedTab: (tab:AgentPricingTab) => dispatch(changeTabCommand(tab))
})

export default connect(mapStateToProps, mapDispatchToProps)(TabMenuBar);